<muni-gameday-panel
  [title]="'Recent Orders'"
  [linkText]="viewAllLinkText | async"
  [linkUrl]="allOrdersUrl"
  [linkParams]="queryParams | async"
  [condensed]="true"
>
  <div class="component">
    <span
      class="empty"
      [hidden]="!(emptyMessage | async)"
      [textContent]="emptyMessage | async"
      data-automation-e2e-selector="recentOrdersEmptyMessageHolder"
    >
    </span>
    <div [hidden]="emptyMessage | async" class="wrapper">
      <ag-grid-angular [theme]="'legacy'"
        class="ag-theme-cupcake recent-orders-table"
        [gridOptions]="gridOptions"
      >
      </ag-grid-angular>
    </div>
  </div>
</muni-gameday-panel>
